import { memo } from "react";

import { Icon } from "@components/Icon";
import { type TTailwindString, tw } from "classnames";

type Direction = "prev" | "next";
type Size = "xs" | "sm" | "lg";

interface Props {
  className?: TTailwindString;
  direction: Direction;
  size?: Size;
}

const styles = {
  button: (direction: Direction, size: Size, className?: TTailwindString) =>
    tw(
      "splide__arrow" as TTailwindString,
      "pointer-events-auto",
      "flex",
      "items-center",
      "justify-center",
      "rounded-full",
      "border",
      "border-solid",
      "border-primary",
      "bg-background-primary",
      "hover:bg-button-secondary-background-hover",
      "active:bg-button-secondary-background-pressed",
      "cursor-pointer",
      "transition-all",
      {
        [tw("w-8", "h-8")]: size === "xs",
        [tw("w-10", "h-10")]: size === "sm",
        [tw("w-12", "h-12", "lg:w-16", "lg:h-16")]: size === "lg",
      },
      {
        [tw("splide__arrow--prev" as TTailwindString)]: direction === "prev",
        [tw("splide__arrow--next" as TTailwindString)]: direction === "next",
      },
      className ? tw(className) : undefined
    ),
  arrowWrapper: (direction: Direction) =>
    tw("relative", "flex", "items-center", "justify-center", {
      [tw("transform rotate-180" as TTailwindString)]: direction === "prev",
    }),
  arrow: (size: Size) =>
    tw("text-primary", {
      [tw("w-2.5", "h-2.5")]: size === "xs",
      [tw("w-4", "h-4")]: size === "sm",
      [tw("w-5", "h-5", "lg:w-6", "lg:h-6")]: size === "lg",
    }),
};

const CarouselArrowBase = ({ className, direction, size = "lg" }: Props) => (
  <button
    className={tw(styles.button(direction, size, className))}
    data-mtr-as="clickModule"
    data-mtr-label={`${direction === "next" ? "forward" : "back"} arrow`}
    data-mtr-track="click"
  >
    <div className={tw(styles.arrowWrapper(direction))}>
      <Icon className={styles.arrow(size)} name="arrow" />
    </div>
  </button>
);

export const CarouselArrow = memo(CarouselArrowBase);
